import { render, staticRenderFns } from "./arviointilomake-valiarviointi.vue?vue&type=template&id=4c3ed204&scoped=true&"
import script from "./arviointilomake-valiarviointi.vue?vue&type=script&lang=ts&"
export * from "./arviointilomake-valiarviointi.vue?vue&type=script&lang=ts&"
import style0 from "./arviointilomake-valiarviointi.vue?vue&type=style&index=0&id=4c3ed204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3ed204",
  null
  
)

export default component.exports